import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParallels } from 'api/services/edu';

export const getParallelsAction = createAsyncThunk('edu/getParallels', () => getParallels());
